import * as allAppend from "./marketoUtil";
import * as allFields from "./marketoFields";

import { MkForm } from "./marketoFormClass";

const excludeFields = (...rest) =>
  rest.reduce((acc, key) => {
    acc[key] = 1;
    return acc;
  }, {});

//  marketo form id
const { appendLandlord, appendLocation, appendResource } = allAppend;
const MarketoFormInterfacesObj = {
  1337: () => new MkForm(),
  1335: () => new MkForm(),
  1338: () => new MkForm(),
  1156: () =>
    new MkForm(allFields.landlordForm, excludeFields(allFields.Phone), [
      appendLandlord,
    ]),
  1340: () => new MkForm(allFields.eventSpaceForm, {}, [appendLocation]),
  1339: () => new MkForm(),
  1124: () => new MkForm(allFields.bookTourForm, {}, [appendLocation]),
  1127: () =>
    new MkForm(allFields.brokerForm, excludeFields(allFields.commentCapture), [
      appendLocation,
    ]),
  1719: () =>
    new MkForm(
      allFields.newsLetterForm,
      excludeFields(
        allFields.FirstName,
        allFields.LastName,
        allFields.Phone,
        allFields.Company,
        allFields.commentCapture
      ),
      [appendLocation]
    ),
  1103: () => new MkForm(allFields.resourceForm, {}, [appendResource]),
  1842: () => new MkForm(allFields.getStarted, {}, [appendLocation]),
  1852: () => new MkForm(allFields.Q42021Reengagement, {}, [appendLocation]),
  1857: () => new MkForm(allFields.Corenet_Form, {}, [appendLocation]),
};

const MarketoFormInterfaces = {
  init(id) {
    this.id = id;
    this.form = document.querySelector(`[id*="${id}_customForm"]`);
    this.formSpecificFields = [];
    this.append = [];

    this.getAllFields();
    this.getAppendFields();
  },

  create(id) {
    //Check if use old forms or new one
    if (
      MarketoFormInterfacesObj[id] &&
      !document.querySelector(`.js-custom-form[id*="${id}"]`)
    ) {
      return MarketoFormInterfacesObj[id]();
    } else {
      this.init(id);
      return new MkForm(this.formSpecificFields, {}, this.append);
    }
  },

  getAllFields() {
    this.formSpecificFields.push({ Custom: true });

    if (!this.form || !this.form.elements) {
      this.form = document.querySelector(`[id*="${this.id}_modalForm"]`);
    }
    //TODO: change this quick fix
    if (!this.form || !this.form.elements) {
      this.form = document.querySelector(`[id*="${this.id}"]`);
    }

    Array.from(this.form.elements).forEach((element) => {
      if (
        (element.type === "radio" && element.checked) ||
        element.type !== "radio"
      ) {
        const field = element.getAttribute("name");
        const value = element.value;
        const object = { name: field, value: value };

        if (field) this.formSpecificFields.push(object);
      }
    });
  },

  getAppendFields() {
    const appendField = this.form.dataset.appendFields;
    if (appendField) this.append.push(allAppend[appendField]);
  },
};

window.MarketoFormInterfaces = MarketoFormInterfaces;

export const getMarketoFormInterface = (id) => MarketoFormInterfaces.create(id);
